import { make } from 'vuex-pathify'
import dottie from 'dottie'
import LunrWrapper from '@/LunrWrapper'
import { api } from '@/api'

/**
 * Function to sort alphabetically an array of objects by some specific key.
 *
 * @param {String} property Key of the object to sort.
 */
function dynamicSort(property) {
  var sortOrder = 1

  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }

  return function(a, b) {
    const num = Number.isInteger(a[property]) && Number.isInteger(b[property])
    if (sortOrder === -1) {
      if (num) return b[property] - a[property]
      return b[property].localeCompare(a[property])
    } else {
      if (num) return a[property] - b[property]
      return a[property].localeCompare(b[property])
    }
  }
}

const state = {
  firms: [],
  sortKey: 'name',
  sortOrder: 'ascend',
  searchTerm: '',
  searchOptions: {
    wildcard: true,
    presence: true
  },
  page: 1,
  limit: 6,
  lunr: null
}

const getters = {
  ...make.getters(state),

  sortedList(state, getters) {
    const sortProperty =
      state.sortOrder === 'ascend' ? state.sortKey : `-${state.sortKey}`
    return getters.filteredList.sort(dynamicSort(sortProperty))
  },

  filteredList: state =>
    state.lunr
      ? state.lunr.query(state.searchTerm, state.searchOptions)
      : state.firms,

  paginatedList: (state, getters) => {
    var begin = (state.page - 1) * state.limit
    var end = begin + state.limit
    return getters.sortedList.slice(begin, end)
  },

  searchTerm: state => state.searchTerm,
  ...make.getters(state)
}

const mutations = {
  ...make.mutations(state),
  read(state, firms) {
    state.firms = firms
    state.lunr = new LunrWrapper(firms, [
      'name',
      'lastname',
      'street',
      'zip',
      'city'
    ])
  }
}

const actions = {
  async list({ commit }) {
    try {
      const response = await api.get('/firms')
      const firms = dottie.get(response, 'data.firms', [])
      commit('read', firms)
    } catch (e) {
      commit('SET_FIRMS', [])
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
